import {SyncEventType} from '../../enums/syncEventType';
import {RealtimeEvent} from './realtimeEvent';

export class EventIssuecardMoved implements RealtimeEvent {

  public readonly type = SyncEventType.ISSUECARD_MOVED;
  public issueId: number;
  public position: any;
  public avatar: string;

  constructor(issueId: number, position: any, avatar: string) {
    this.issueId = issueId;
    this.position = position;
    this.avatar = avatar;
  }

  getPayload(): object {
    return {
      'issueId': this.issueId,
      'position': this.position,
      'avatar': this.avatar
    };
  }

  static fromPayload(payload: any): EventIssuecardMoved {
    return new EventIssuecardMoved(
      payload['issueId'],
      payload['position'],
      payload['avatar']
    );
  }

}

